<template>
  <div>
    <div :class="['filters__item', isActive ? 'active' : 'passive']">
      <span @click="openFilter">{{ title }}</span>
      <span :class="isActive ? 'btn-active' : 'btn-passive'" @click="changeFilter" />
    </div>
    <el-dialog
      :visible.sync="isModalOpen"
      width="100%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="filter__modal"
    >
      <div class="filter__modal-title">
        <div class="title__text">{{ modalTitle }}</div>
        <div class="title__close" @click="closeModal">Готово</div>
      </div>
      <div class="filter__modal-content">
        <new-checkbox
          v-for="(item, index) in items"
          :key="index"
          :init-state="false"
          :drop-checkbox="dropCheckboxes"
          @change-checkbox="changeCheckbox(item.label)"
        >
          <template slot="content">
            <div class="checkbox__item">{{ item.title }}</div>
          </template>
        </new-checkbox>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NewCheckbox from '@/components/Drivers/NewCheckbox/NewCheckbox'
export default {
  name: 'FilterSelect',
  components: { NewCheckbox },
  props: {
    title: {
      type: String,
      default: '',
    },
    modalTitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isModalOpen: false,
      result: [],
      dropCheckboxes: true,
    }
  },
  computed: {
    isActive() {
      return this.result.length
    },
  },
  methods: {
    // нажатие на заголовок кнопки
    openFilter() {
      this.isModalOpen = true
      this.dropCheckboxes = false
    },
    // нажатие на иконку (галочка или крестик)
    changeFilter() {
      if (!this.isActive) {
        this.openFilter()
      } else {
        // сброс фильтра
        this.result = []
        this.dropCheckboxes = true
        this.$emit('set-filter', this.result)
      }
    },
    // нажатие на Готово
    closeModal() {
      this.isModalOpen = false
      this.$emit('set-filter', this.result)
    },
    changeCheckbox(element) {
      if (this.result.includes(element)) {
        this.result.splice(this.result.indexOf(element), 1)
      } else {
        this.result.push(element)
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.filters__item
  display: flex
  justify-content: center
  align-items: center
  height: 3.4rem
  padding: 0 1.2rem
  font-size: 1.4rem
  font-weight: 700
  line-height: 1.8rem
  border-radius: .8rem
  &.active
    background: #EBF9EB
    color: $mainColor
    border: none
  &.passive
    background: #FFFFFF
    color: #5C5C5C
    border: 1px solid #EDEDED

  .btn-active, .btn-passive
    width: 1.6rem
    height: 1.6rem
    margin-left: .4rem
    background-size: cover
  .btn-active
    background-image: url('~@/assets/img/new-close.svg')
  .btn-passive
    background-image: url('~@/assets/img/new-angle-down.svg')

.filter__modal
  &-title
    display: flex
    justify-content: space-between
    align-items: center
    padding: 2.1rem 1.6rem 1.3rem
    border-bottom: 1px solid #EDEDED
    .title__text
      font-size: 1.4rem
      font-weight: 400
      line-height: 1.8rem
      color: #5C5C5C
    .title__close
      font-size: 1.4rem
      font-weight: 800
      line-height: 1.6rem
      color: $mainColor
      cursor: pointer
  &-content
    height: 25.1rem
    padding: 1.2rem 1.6rem
    overflow: scroll
::v-deep .el-dialog
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  width: calc(100% - 3.2rem) !important
  height: 30.6rem
  margin-top: 0 !important
  border-radius: 1.2rem !important
  box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)
  &__header
    display: none
  &__body
    padding: 0
::v-deep .v-modal
  background: #2B2B2B
  opacity: .7
</style>
